import {
  IonImg, IonLabel, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs,
} from '@ionic/react';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';

import LearningSvg from '@/assets/icons/learning.svg';
import LearningSelected from '@/assets/icons/learning-selected.svg';
import Operations from '@/assets/icons/operations.svg';
import OperationsSelected from '@/assets/icons/operations-selected.svg';
import ProfileSvg from '@/assets/icons/profile.svg';
import ProfileSelected from '@/assets/icons/profile-selected.svg';
import Reports from '@/assets/icons/reports.svg';
import ReportsSelected from '@/assets/icons/reports-selected.svg';
import { ROUTES_PATH } from '@/constants';
import { AppPage } from '@/interfaces/AppMenu/AppMenu';
import LoggedRoutes from '@/router/loggedRoutes';

export default function MobileLayout() {
  const location = useLocation();
  const appPages: AppPage[] = [
    {
      title: 'Operaciones',
      url: ROUTES_PATH.OPERATION_DASHBOARD,
      src: Operations,
      srcSelected: OperationsSelected,
    },
    {
      title: 'Reporting',
      url: ROUTES_PATH.REPORTING,
      src: Reports,
      srcSelected: ReportsSelected,
    },
    {
      title: 'Formación',
      url: ROUTES_PATH.LEARNING,
      src: LearningSvg,
      srcSelected: LearningSelected,
    },
    {
      title: 'Mi perfil',
      url: ROUTES_PATH.PROFILE,
      src: ProfileSvg,
      srcSelected: ProfileSelected,
    },
  ];
  const [tabSelected, setTabSelected] = useState<AppPage>(appPages[0]);
  const [enabledMenu, setEnabledMenu] = useState<boolean>(true);

  useEffect(() => {
    const tabSelected = appPages?.find(
      (elem) => elem.url === location.pathname,
    );

    if (tabSelected) {
      setTabSelected(tabSelected);
      setEnabledMenu(true);
    } else {
      setEnabledMenu(false);
    }
  }, [location.pathname]);
  // 1. Constante con las rutas
  const ROUTES_WITHOUT_TABS = [
    'login', 'reset-password', 'change-password', 'configuration', 'contact',
    'detail-operation', 'operation-refund', 'onboarding', 'all-resources-mobile',
    'help', 'faq', 'terms-of-use', 'documents', 'article', 'webinar',
    'actualiza-datos-seguridad-social', 'alta-cl',
  ];

  // 2. Dentro del componente
  const outletRef = useRef<HTMLIonRouterOutletElement>(null);
  const isRouteWithoutTabs = ROUTES_WITHOUT_TABS.some(
    (r) => location.pathname.includes(r),
  );

  useEffect(() => {
    const outlet = outletRef.current;
    if (!outlet) return;
    if (isRouteWithoutTabs) {
      outlet.classList.add('safe-area-padding');
      outlet.classList.remove('only-safe-area-top');
    } else {
      outlet.classList.remove('safe-area-padding');
      outlet.classList.add('only-safe-area-top');
    }
    return () => {
      outlet.classList.remove('safe-area-padding');
      outlet.classList.remove('only-safe-area-top');
    };
  }, [isRouteWithoutTabs]);
  return (
    <IonTabs className="mobile-tablet">
      <IonRouterOutlet ref={outletRef}>
        <LoggedRoutes />
      </IonRouterOutlet>
      <IonTabBar
        slot="bottom"
        className={`mobile-tablet tabs-wrapper ${(location.pathname.includes('login')
          || location.pathname.includes('reset-password')
          || location.pathname.includes('change-password')
          || location.pathname.includes('configuration')
          || location.pathname.includes('contact')
          || location.pathname.includes('detail-operation')
          || location.pathname.includes('operation-refund')
          || location.pathname.includes('onboarding')
          || location.pathname.includes('all-resources-mobile')
          || location.pathname.includes('help')
          || location.pathname.includes('faq')
          || location.pathname.includes('terms-of-use')
          || location.pathname.includes('actualiza-datos-seguridad-social')
          || location.pathname.includes('alta-cl')
          || location.pathname.includes('documents')
          || location.pathname.includes('article')
          || location.pathname.includes('webinar'))
          && 'disabled'
          }`}
      >
        {appPages.map((appPage, index) => (
          <IonTabButton
            className="menu-tab-btn"
            tab={appPage.title}
            href={appPage.url}
            key={appPage.title}
            selected={tabSelected.title === appPage.title}
          >
            <div className="selected-line" />
            <IonImg src={
              tabSelected.title === appPage.title
                && enabledMenu
                ? appPage.srcSelected
                : appPage.src
            }
            />
            <IonLabel className="menu-tab-label">{appPage.title}</IonLabel>
          </IonTabButton>
        ))}
      </IonTabBar>
    </IonTabs>
  );
}
